import React, { useState } from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";
import { Link } from "@quintype/components";
import get from "lodash/get";

import Headline from "../../atoms/headline";

import { getHeadline } from "../../utils/utils";
import translate from "../../translate";

import "./bigStorySingleCollection.m.css";

const BigStorySingleCollection = ({ slug, collection, publisherName }) => {
  const [showStories, setShowStories] = useState(false);
  const collectionSlug = `${slug}/${collection.slug}`;

  if (!(collection && collection.items)) {
    return null;
  }

  const stories = collection.items.filter((item) => item.type === "story").map((item) => item.story);

  if (!stories.length) {
    return null;
  }

  const toggleShowStoryView = () => setShowStories(!showStories);

  const getStoryListView = () =>
    stories.length &&
    stories.slice(0, 2).map((story, index) => (
      <Link href={story.url} key={index}>
        <Headline text={getHeadline(story)} headerType={2} story={story} />
      </Link>
    ));

  const getCollectionNameView = () => (
    <React.Fragment>
      <span styleName="line"></span>
      <span styleName="collection-name">{collection.name}</span>
    </React.Fragment>
  );

  return (
    <div styleName="wrapper" className="big-story-single-collection" id={collection.slug}>
      <Link href={collectionSlug} styleName="collection-view-desktop">
        <div styleName="name-view">{getCollectionNameView()}</div>
        <div styleName="summary">{collection.summary}</div>
      </Link>

      <Link href={collectionSlug} styleName="collection-view-mobile">
        <div styleName="mobile-name-view">
          {showStories ? (
            <span styleName="collection-name-background">{collection.name}</span>
          ) : (
            getCollectionNameView()
          )}
        </div>
        {!showStories && <div styleName="summary">{collection.summary}</div>}
      </Link>

      <div styleName="desktop-story-list">{getStoryListView()}</div>

      {showStories && <div styleName="mobile-story-list">{getStoryListView()}</div>}

      <div styleName="more">
        <Link href={collectionSlug}>
          {collection["total-count"]} {translate(publisherName, "more")}
        </Link>
        <Link href={collectionSlug} styleName="read-more">
          {translate(publisherName, "read_more")}
        </Link>
        <div styleName={showStories ? "expand-bottom" : "expand-top"} onClick={toggleShowStoryView}>
          {showStories ? translate(publisherName, "collapse") : translate(publisherName, "expand")}
        </div>
      </div>
    </div>
  );
};

BigStorySingleCollection.propTypes = {
  collection: object.isRequired,
  slug: string,
  publisherName: string,
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

export default connect(mapStateToProps, null)(BigStorySingleCollection);
